import freightApi2 from '../../service/modules/freight.api';

export async function acceptTransportFromQueue({
  freightId,
  transport,
  user,
}) {
  if (!freightId || !transport?.idTransport) {
    throw new Error('Frete ou transportadora não identificados.');
  }

  const idUser = user?.uid || '';
  if (!idUser) {
    throw new Error('Usuário não identificado.');
  }

  return freightApi2.acceptTransportQueue(freightId, {
    idCarrier: transport.idTransport,
    nameCarrier: transport.name || '',
    idUser,
  });
}

export function getAcceptTransportErrorMessage(error, fallback) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  );
}
